export default __webpack_public_path__ + "static/media/tk.16bf538d.svg";